// declare immutable objects
export const authProtectedRoutes = Object.freeze([
  // '/dashboard',
  // '/analytics',
  '/cash-flow',
  // '/balance',
  // '/balance/history/:id',
  '/changepassword',
  // '/transaction',
  // '/transaction/:id',
  '/settlement',
  '/settlement/:type',
  // '/settlement/report/detail',
  // '/logs',
  // '/logs/:id',
  // '/payment-link',
  // '/payment-link/:id',
  // '/payment-link/create',
  '/merchant',
  '/merchant/:id',
  '/add-merchant',
  '/edit-merchant/:id',
  // '/account-group',
  // '/account-group/:id/',
  // '/group/:id/:type',
  // '/group/add-group',
  // '/group/edit-group/:id',
  // '/group/:id/invite-user',
  // '/group/:id/invite-merchant',
  //   '/invite-new-admin',
  // '/virtual-account',
  // '/virtual-account/:id',
  // '/ewallet',
  // '/ewallet/:id',
  // '/qris-payment',
  // '/qris-payment/:id',
  // '/deposit-va',
  // '/deposit-va/:id',
  '/disbursement',
  '/disbursement/:id',
  '/disbursement/batch/:id',
  // '/direct-debit',
  // '/direct-debit/:id',
] as const);

export const profileProtectedRoute = Object.freeze([
  '/profile',
  '/business-profile',
  '/users',
  // '/settings',
  // '/manage-notifications',
  '/api-settings',
  // '/brand-settings',
  '/change-password',
] as const);
